<template>
  <div class="settle-order-manage">
    <el-card shadow="always">
      <el-form ref="formInline" size="small" :model="filter" inline>
        <el-form-item label="验收单状态">
          <el-select
            style="width: 200px"
            v-model="filter.auditStatus"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1" />
            <el-option label="教务服务方初审中" :value="1" />
            <el-option label="教务服务方初审驳回" :value="2" />
            <el-option label="教务复审中" :value="3" />
            <el-option label="教务复审驳回" :value="4" />
            <el-option label="财务复审中" :value="5" />
            <el-option label="财务复审驳回" :value="6" />
            <el-option label="审核通过" :value="7" />
          </el-select>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            v-model="applyDate"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="验收订单编号">
          <el-input v-model="filter.id" placeholder="请输入验收订单编号" clearable />
        </el-form-item>
        <el-form-item style="margin-left: 50px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <el-radio-group v-model="filter.auditStatus" v-if="$myStore.state.user.userIdentity === 0" size="small" @input="handleSearch">
        <el-radio-button label="-1">全部</el-radio-button>
        <el-radio-button :label="3">教务复审</el-radio-button>
        <el-radio-button :label="5">财务复审</el-radio-button>
        <el-radio-button :label="4">教务复审驳回</el-radio-button>
        <el-radio-button :label="6">财务复审驳回</el-radio-button>
      </el-radio-group>
      <el-radio-group v-model="filter.agentStatus" v-else-if="$myStore.state.user.userIdentity === 1" size="small" @input="handleSearch">
        <el-radio-button :label="1">全部</el-radio-button>
        <el-radio-button :label="2">待审核</el-radio-button>
        <el-radio-button :label="3">已提交</el-radio-button>
        <el-radio-button :label="4">初审驳回</el-radio-button>
      </el-radio-group>
      <el-table border v-loading="loading" :data="list" style="width:100%;margin-top:10px">
        <el-table-column label="验收订单编号" minWidth="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.id || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="关联教务服务方" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.agentName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="关联招生服务方" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.distributionName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="验收单状态" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.auditStatus === 1">教务服务方初审中</span>
            <span v-else-if="row.auditStatus === 2">教务服务方初审驳回</span>
            <span v-else-if="row.auditStatus === 3">教务复审中</span>
            <span v-else-if="row.auditStatus === 4">教务复审驳回</span>
            <span v-else-if="row.auditStatus === 5">财务复审中</span>
            <span v-else-if="row.auditStatus === 6">财务复审驳回</span>
            <span v-else-if="row.auditStatus === 7">审核通过</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column label="申请单数" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.applyOrderNum }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单金额/元" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.applyOrderAmount || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="招生服务方结算金额/元" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.distributionAmount || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="$myStore.state.user.userIdentity !== 2" label="教务服务方结算金额/元" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.agentAmount || "--" }}</span>
          </template>
        </el-table-column>

        <el-table-column label="招生服务方退回保证金金额/元" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.distributionBondAmount || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="$myStore.state.user.userIdentity !== 2" label="教务服务方退回保证金金额/元" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.agentBondAmount || "--" }}</span>
          </template>
        </el-table-column>

        <el-table-column label="申请人" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.applyUserName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="applyDate" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.applyDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="208" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="toRelevant(row)">关联订单</el-button>
            <el-button type="text" size="mini" @click="toBillDetail(row.id)">验收详情</el-button>
            <!-- <el-button v-if="[2,4,6].includes(row.auditStatus)" type="text" size="mini" @click="toAddReceipt(row.id)">再次发起</el-button> -->
            <template v-if="row.auditStatus === 7">
              <el-button type="text" size="mini" @click="toDownloadReceipt(row.id, row.isAgentFlag)">下载验收结算单</el-button>
              <el-button type="text" size="mini" @click="handleViewImage(row.id)">查看银行回单</el-button>
            </template>
            <!-- <el-button v-if="checkAdmin()" type="text" size="mini" @click="updateConfig(row.id)">更新退回保证金金额</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>
    <RelevantList ref="RelevantListEl" />
    <BillDetail ref="BillDetailEl" :filter="filter" :applyDate="applyDate" @refresh="handleGetListPage" />
    <DocProcess
      ref="DocProcessEl"
      title="下载验收结算单"
      contentTitle="招生验收结算单"
      :templatePath="templatePath"
      :info="docInfo"
    />
    <el-image-viewer v-if="showImagePreview" :on-close="closeImgViewer" :url-list="[previewImgUrl]" />
  </div>
</template>

<script>
import {
  checkAcceptByOrderListPage,
  // addAgainCheckAccept,
  getCheckAcceptByOrder,
  checkAcceptDataByOrder,
  // updateBondAmountData
} from "@/api/orderAdmin/orderList"
import RelevantList from '../billManage/components/relevantList.vue'
import BillDetail from './components/billDetail.vue'
import DocProcess from '@/components/docProcess'
import myPagination from "@/components/myPagination.vue"
import { processing } from "@/utils/handle.js"

export default {
  name: 'ReceiptManage',

  components: {
    RelevantList,
    BillDetail,
    DocProcess,
    myPagination,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data () {
    return {
      filter: {
        auditStatus: '-1',
        applyStartDate: '',
        applyEndDate: '',
        auditStatus: '-1',
        agentStatus: 1,
        id: ''
      },
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      applyDate: [],
      loading: false,
      list: [],
      showImagePreview: false,
      previewImgUrl: '',
      docInfo: {},
      templatePath: ''
    }
  },
  created () {
    this.handleGetListPage()
  },
  methods: {
    // 搜索
    handleSearch() {
      this.filter.page = 1
      this.handleGetListPage()
    },
    // 重置
    handleReset() {
      this.filter = this.$options.data().filter
      this.pageInfo = this.$options.data().pageInfo
      this.applyDate = []
      this.list = []
      this.handleGetListPage()
    },
    handleGetListPage () {
      if (this.applyDate && this.applyDate.length !== 0)  {
        this.filter.applyStartDate = this.applyDate[0]
        this.filter.applyEndDate = this.applyDate[1]
      }
      const params = { ...processing(this.filter), ...this.pageInfo }
      params.flag = this.$myStore.state.user.userIdentity
      if (params.flag !== 1) {
        delete params.agentStatus
      }
      this.loading = true
      checkAcceptByOrderListPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.list = data.records
          this.pageInfo.total = +data.total
        }
      }).finally(() => {
        this.loading = false
      })
    },
    toRelevant(row) {
      const payload = {
        ...row,
        id: row.balanceId,
        receiptId: row.id,
        isByOrder: true
      }
      this.$refs.RelevantListEl.init(payload)
    },
    toBillDetail(id) {
      this.$refs.BillDetailEl.init(id)
    },
    toBillList(id) {
      this.$refs.BillEdListEl.init(id)
    },
    toAddReceipt(id) {
      this.$confirm(`是否确认再次发起验收结算申请?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await addAgainCheckAccept({ id })
        if (res.code !== 0) {
          this.$message.error(res.message)
          return
        }
        this.$message.success('再次发起验收结算申请成功！')
        this.handleGetListPage()
      })
    },
    toDownloadReceipt (id, isAgentFlag) {
      if (this.$myStore.state.user.userIdentity !== 1) {
        isAgentFlag = 1
      }
      switch (isAgentFlag) {
        case 1:
          this.templatePath = `${this.$BASEURL}/docTemplate/zsysjs.docx`
          break
        case 2:
          this.templatePath = `${this.$BASEURL}/docTemplate/dlysjs.docx`
          break
        default:
          this.templatePath = `${this.$BASEURL}/docTemplate/zsysjs.docx`
          break
      }
      checkAcceptDataByOrder({ id }, isAgentFlag).then(({ code, data }) => {
        if (code === 0) {
          this.docInfo = {
            companyName: this.serializeData(data.companyName),
            number: this.serializeData(data.number),
            skuName: this.serializeData(data.skuName),
            month: this.serializeData(data.month),
            batchNo: this.serializeData(data.batchNo),
            num: this.serializeData(data.num),
            checkAcceptStandard: this.serializeData(data.checkAcceptStandard),
            accumulateBalanceNum: this.serializeData(data.accumulateBalanceNum),
            accumulateCheckAcceptNum: this.serializeData(data.accumulateCheckAcceptNum),
            accumulateBond: this.serializeData(data.accumulateBond),
            addDeductBond: this.serializeData(data.addDeductBond),
            actualBond: this.serializeData(data.actualBond),
            returnBond: this.serializeData(data.returnBond),
            actualReturnBond: this.serializeData(data.actualReturnBond),
            insertName: this.serializeData(data.insertName),
            insertDate: this.serializeData(data.insertDate),
            agentAuditName: this.serializeData(data.agentAuditName),
            agentAuditDate: this.serializeData(data.agentAuditDate),
            educationalAuditName: this.serializeData(data.educationalAuditName),
            educationalAuditDate: this.serializeData(data.educationalAuditDate),
            financeAuditName: this.serializeData(data.financeAuditName),
            financeAuditDate: this.serializeData(data.financeAuditDate)
          }
          this.$refs.DocProcessEl.init()
        }
      })
    },
    serializeData (val) {
      if (val || val === 0 || val === '0') {
        return val
      }
      return '--'
    },
    // 更新结算单结算金额
    updateConfig (id) {
      this.$confirm(`是否确认更新退回保证金金额?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await updateBondAmountData({ id })
        if (res.code !== 0) {
          this.$message.error(res.message)
          return
        }
        this.$message.success('更新退回保证金金额成功!')
        this.handleGetListPage()
      })
    },
    handleViewImage(id) {
      getCheckAcceptByOrder({ id }).then(({ code, data }) => {
        if (code === 0 && data.bankReceiptUrl) {
          if (/^[\s\S]*\.pdf$/.test(data.bankReceiptUrl)) {
            window.open(data.bankReceiptUrl)
          } else {
            this.previewImgUrl = data.bankReceiptUrl
            this.showImagePreview = true
          }
        } else {
          this.$message.error('暂时没有银行回单数据!')
        }
      })
    },
    closeImgViewer() {
      this.showImagePreview = false
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.pageInfo.page = payload
      this.handleGetListPage()
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.pageInfo.limit = payload
      this.handleGetListPage()
    }
  }
}
</script>

<style>

</style>
